module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_1536.e1b1e24b.jpg";